
import './index.less'
import React from 'react'

import { useState } from 'react'
console.log(React)
export default function EffectDisplay(props) {
  const [ifon, setIfon] = useState({
    isOpen: false
  })

  return (<div className={`effectDisplay`}>
    <div className='effectDisplay_titleArea' onClick={() => {
      setIfon({
        ...ifon,
        isOpen: !ifon.isOpen
      })
    }}>
      <span className='title'>{props.children}</span>
      <i className='icon'>{'>'}</i>
    </div>
    <div className='effectDisplay_content' style={{
      display: ifon.isOpen ? 'block' : 'none'
    }}>
      <img className='content_img' src={props.src} />
    </div>
  </div>)
}

